import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { SponsorsComponent } from 'src/app/components/sponsors/sponsors.component';
import { SepecialButtonsComponent } from 'src/app/components/sepecial-buttons/sepecial-buttons.component';
import { CatalogueProductsComponent } from 'src/app/components/catalogue-products/catalogue-products.component';
import { CatalogueHomeComponent } from 'src/app/components/catalogue-home/catalogue-home.component';
import { PwaComponent } from 'src/app/components/pwa/pwa.component';
import { GiftCardHomeComponent } from 'src/app/components/gift-card-home/gift-card-home.component';
import { TranslateModule } from '@ngx-translate/core';
import { InstagramComponent } from 'src/app/pages/home/home-components/instagram/instagram.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { GalleryComponentsModule } from 'src/app/gallery-components/gallery-components.module';
import { CatalogueComponentsModule } from 'src/app/catalogue-components/catalogue-components.module';
import { MapsComponentsModule } from 'src/app/maps-components/maps-components.module';
import { AddAnimDirective } from 'ignoreGit/add-anim.directive';
import { SliderModule } from 'src/app/components/slider/slider.module';
import { RateOperatorComponent } from '../../calendar/components/rate-operator/rate-operator.component';
import { StarRatingModule } from 'angular-star-rating';
import { FormsModule } from '@angular/forms';
import { PwaAlertIosComponent } from 'src/app/components/pwa-alert-ios/pwa-alert-ios.component';

const declarations = [
  SponsorsComponent,
  SepecialButtonsComponent,
  CatalogueProductsComponent,
  CatalogueHomeComponent,
  PwaComponent,
  PwaAlertIosComponent,
  GiftCardHomeComponent,
  InstagramComponent,
  AddAnimDirective,
  RateOperatorComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    GeneralesComponentsModule,
    TranslateModule,
    DirectivesModule,
    PipeModule,
    GalleryComponentsModule,
    CatalogueComponentsModule,
    MapsComponentsModule,
    SliderModule,
    StarRatingModule,
    FormsModule,
  ],
  exports: declarations,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponentsModule {}
